import {
  Loader2, PlusCircle, Check, XCircle, Layers
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  } catch { return dateStr; }
};

const getStatusBadge = (onTime, delayDays) => {
  if (onTime) return <Badge className="bg-emerald-500/10 text-emerald-600 border-emerald-200">On Time</Badge>;
  return <Badge variant="destructive">{delayDays} days late</Badge>;
};

const getPOStatusIcon = (status) => {
  if (status === "loading") return <Loader2 className="w-4 h-4 animate-spin text-primary" />;
  if (status === "success") return <Check className="w-4 h-4 text-emerald-500" />;
  if (status === "error") return <XCircle className="w-4 h-4 text-red-500" />;
  return null;
};

const OrdersTable = ({
  orders, selectedOrders, creatingPO,
  onToggleOrder, onToggleAll, onCreateSingle, onCreateBatch,
}) => {
  return (
    <div>
      {/* Batch PO actions */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Checkbox
            checked={selectedOrders.size === (orders?.length || 0) && selectedOrders.size > 0}
            onCheckedChange={onToggleAll}
            data-testid="select-all-orders"
          />
          <span>{selectedOrders.size} of {orders?.length || 0} selected</span>
        </div>
        {selectedOrders.size > 0 && (
          <Button onClick={onCreateBatch} size="sm" data-testid="create-batch-po-btn">
            <Layers className="w-4 h-4 mr-2" />
            Create {selectedOrders.size} Production Orders
          </Button>
        )}
      </div>

      <div className="max-h-[500px] overflow-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-10" />
              <TableHead>Order ID</TableHead>
              <TableHead>Material</TableHead>
              <TableHead className="text-right">Quantity</TableHead>
              <TableHead>Due Date</TableHead>
              <TableHead>Start</TableHead>
              <TableHead>End</TableHead>
              <TableHead>Ops</TableHead>
              <TableHead>Hours</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-center">Create PO</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {orders?.map((order, idx) => (
              <TableRow key={idx}>
                <TableCell>
                  <Checkbox
                    checked={selectedOrders.has(order.order_id)}
                    onCheckedChange={() => onToggleOrder(order.order_id)}
                    data-testid={`select-order-${idx}`}
                  />
                </TableCell>
                <TableCell className="font-medium text-xs">{order.order_id}</TableCell>
                <TableCell className="text-xs">{order.material}</TableCell>
                <TableCell className="text-right text-xs">{order.quantity}</TableCell>
                <TableCell className="text-xs">{formatDate(order.due_date)}</TableCell>
                <TableCell className="text-xs">{formatDate(order.scheduled_start)}</TableCell>
                <TableCell className="text-xs">{formatDate(order.scheduled_end)}</TableCell>
                <TableCell><Badge variant="secondary" className="text-xs">{order.total_operations}</Badge></TableCell>
                <TableCell className="text-xs">{order.total_hours}h</TableCell>
                <TableCell>{getStatusBadge(order.on_time, order.delay_days)}</TableCell>
                <TableCell className="text-center">
                  {creatingPO[order.order_id] ? (
                    getPOStatusIcon(creatingPO[order.order_id])
                  ) : (
                    <Button variant="ghost" size="sm" onClick={() => onCreateSingle(order)} data-testid={`create-po-${idx}`}>
                      <PlusCircle className="w-4 h-4 text-primary" />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default OrdersTable;
